import { createFileRoute, Outlet } from "@tanstack/react-router";
import { EmptyState } from "@/components/app/lists/empty-state";
import { OneBuildingCard } from "@/components/app/workspace/one-building-card";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { AdmissionSettingsNav } from "@/routes/_authenticated/_administration/settings/-components/forms/admission-settings-nav";
import { useAdmissionFacility } from "@/routes/_authenticated/_administration/settings/-components/forms/use-admission-facility";

export const Route = createFileRoute("/_authenticated/_administration/settings/move-in")({
  beforeLoad: ({ context }) => guardRoute(context.me, "admission-forms"),
  component: MoveInPackets,
});

/** What a building's move-in packet holds: which forms it offers, saved sets of them, and the
 * fields each form needs answered. All three are kept per building. */
function MoveInPackets() {
  const facility = useAdmissionFacility();
  const header = (
    <PageHeader
      title="Move-in packets"
      meta="Which forms a new packet holds at this building, saved sets of forms for other stays, and the fields each form needs answered."
    />
  );

  if (!facility.isLoading && facility.facilities.length === 0) {
    return (
      <>
        {header}
        <EmptyState
          title="No facilities yet"
          description="Add a facility under Facilities first. Move-in packets are set up per facility."
        />
      </>
    );
  }
  if (facility.needsChoice) {
    return (
      <>
        {header}
        <OneBuildingCard prompt="Move-in packets are set up per building. Choose the building to set up." />
      </>
    );
  }
  return (
    <>
      {header}
      <AdmissionSettingsNav />
      <Outlet />
    </>
  );
}
